import {sexes} from '@/constants/global-constants';

export const getMemberSexesOptions = () => {
    let array = [];
    Object.keys(sexes).forEach((key) => {
        array.push({
            value: key,
            text: sexes[key]
        });
    });
    return array;
};